<template>
  <div class="mainContent grid finance">
    <div class="page-block u-16">
      <div class="grid">
        <div class="title-page"><h1>Финансы</h1></div>
      </div>
      <div class="filters grid">
        <div class="date-picker ver-margin-5 r-margin-10">
          <Calendar :options="rangeCalendar" v-on:vdp-change="dateChange" />
        </div>
        <!-- /.date-picker -->
        <div class="select__filter r-margin-10" v-if="activeName == 'by_merchant'">
          <el-select
            v-model="request.merchants"
            multiple
            filterable
            clearable
            collapse-tags
            placeholder="Предприятие"
            class="merchant ver-margin-5"
            @change="onValueChange"
          >
            <el-option
              v-for="item in merchantList"
              :key="item.id"
              :label="item.human_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <!-- ./select__merchants -->
        <div class="select__filter r-margin-10" v-if="terminalList.length > 0">
          <el-select
            v-model="request.terminals"
            multiple
            filterable
            clearable
            collapse-tags
            placeholder="Терминал"
            class="terminal ver-margin-5"
          >
            <el-option v-for="item in terminalListSort" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <!-- /.select__terminals -->
        <div
          class="select__filter r-margin-10 ver-margin-5"
          v-if="processingList.length > 0 && activeName == 'by_processing'"
        >
          <el-select
            v-model="request.processings"
            multiple
            filterable
            clearable
            collapse-tags
            placeholder="Процессинг"
            class="processing"
          >
            <el-option
              v-for="item in processingListSort"
              :key="item.id"
              :label="item.human_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <!-- /.select__processing -->
        <div>
          <el-button class="btn search-btn ver-margin-5" @click.prevent="applyFilters(activeName)" :loading="loading"
            >Применить</el-button
          >
        </div>
      </div>

      <div class="u-16" style="margin-top: 15px" v-if="!isValidConversion">
        <el-alert
          title="На данный момент суммовые показатели сконвертированы не полностью. Для получения актуальных данных повторите запрос позже"
          type="warning"
          show-icon
        >
        </el-alert>
      </div>

      <div class="finance_content">
        <el-tabs v-model="activeName" @tab-click="handleClickTab">
          <el-tab-pane label="По предприятиям" name="by_merchant">
            <el-table
              :data="tableData"
              size="medium"
              v-loading="loading"
              row-key="id"
              @row-click="rowClick"
              :row-class-name="rowClass"
              class="finance-table"
              ref="tfinance"
              :height="tHeight"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table :data="props.row.terminals" class="finance-terminals" size="medium">
                    <el-table-column prop="name">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="amount">
                      <template slot-scope="scope">
                        <span
                          >{{ scope.row.amount | amountFormat }} {{ currencyCharacter(scope.row.currency_code) }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column prop="count">
                      <template slot-scope="scope">
                        <span>{{ scope.row.count | countFormat }} шт.</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="Предприятие" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="Оборот" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.amount | amountFormat }} {{ merchantCurrencyCode(scope.row.id) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="Количество транзакций (шт.)" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.count | countFormat }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="total-info grid cross-center">
              <div class="u text-right grid cross-center between">
                <el-button type="primary" size="medium" class="download" @click.prevent="downloadReport(activeName)">
                  <i class="el-icon-download"></i> Скачать отчет
                </el-button>
                <div>Итого</div>
              </div>
              <div class="u l-padding-50">{{ getSumm.totalAmount | amountFormat }} {{ totalCurrencyChar }}</div>
              <div class="u">{{ getSumm.totalCount | countFormat }} шт.</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="По процессингу" name="by_processing">
            <div class="grid">
              <div class="u-16">
                <b-dropdown>
                  <button class="button button-white" slot="trigger">
                    <b-icon icon="settings-outline" size="is-small"></b-icon>
                    <span>Управление столбцами</span>
                  </button>
                  <b-dropdown-item custom>
                    <div v-for="(proc, index) in processings" :key="index" class="control u-16">
                      <b-checkbox v-model="proc.show" size="is-small">{{
                        processingName(proc.processing_id)
                      }}</b-checkbox>
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
              </div>

              <el-table
                :data="tableProcessing"
                size="medium"
                v-loading="loading"
                @row-click="rowClickP"
                class="u-16 processing-table"
                style="width:100%"
                ref="tprocessing"
                :height="tHeight"
                :summary-method="getSummaries"
                show-summary
              >
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table :data="props.row.terminals" class="finance-terminals" size="medium">
                      <el-table-column prop="id" width="320">
                        <template slot-scope="scope">
                          <span>{{ terminalName(scope.row.id) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Итого"
                        :formatter="totalFormatter"
                        width="200"
                        class-name="total"
                        align="right"
                      ></el-table-column>
                      <el-table-column
                        v-for="proc in pShow"
                        :key="proc.processing_id"
                        :prop="JSON.stringify({ proc: proc.processing_id })"
                        :formatter="cellFormatter"
                        min-width="200"
                        align="right"
                      ></el-table-column>
                    </el-table>
                  </template>
                </el-table-column>

                <el-table-column prop="name" label="Мерчант" width="320" sortable>
                  <template slot-scope="scope">
                    <span>
                      <strong>{{ scope.row.name }}</strong>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Итого"
                  :formatter="totalFormatter"
                  width="200"
                  class-name="totalb"
                  label-class-name="total-label"
                  align="right"
                  prop="amount"
                  sortable
                >
                  <template slot-scope="scope">
                    <span
                      >{{ scope.row.amount | amountFormat }} {{ merchantProcessingCurrencyCode(scope.row.id) }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  :label="processingName(proc.processing_id)"
                  v-for="proc in pShow"
                  :key="proc.processing_id"
                  :prop="JSON.stringify({ proc: proc.processing_id })"
                  :formatter="cellFormatter"
                  min-width="200"
                  class-name="cellbold"
                  align="right"
                ></el-table-column>
              </el-table>
              <!-- /. processing-table -->
            </div>
            <div class="total-info grid cross-center">
              <div class="u text-right grid cross-center between">
                <el-button type="primary" size="medium" class="download" @click.prevent="downloadReport(activeName)">
                  <i class="el-icon-download"></i> Скачать отчет
                </el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- /.finance_content -->
    </div>
  </div>
</template>

<script>
var icons = document.getElementsByClassName("el-table__expand-icon");

import Vuex from "vuex";
import { mapGetters } from "vuex";
import store from "../store";
import { apiUrl } from "@/api/apiUrl";
import moment from "moment";

import Calendar from "@/components/calendar/calendar";
import { _ } from "underscore";
import axios from "axios";
import terminals from "../store/modules/terminals";
export default {
  name: "Finance",
  data() {
    return {
      loading: false,
      request: {
        merchants: [],
        terminals: [],
        processings: [],
        date_range: [],
        period: "borders",
        finance: true,
        expect: ["merchant_verbose"],
      },
      temp_m: {
        terminals: [],
        merchants: [],
        processings: [],
      },
      temp_p: {
        terminals: [],
        merchants: [],
        processings: [],
      },
      activeName: "by_merchant",
      rangeCalendar: {
        type: "rangedate",
        locale: "ru",
        startDate: moment().startOf("month"),
        endDate: moment(),
        maxDate: moment().add(0, "day"),
        format: "DD.MM.YYYY",
      },
      tableData: null,
      tableProcessing: null,
      processings: [],
      tHeight: 0,
      totalCurrencyChar: "",
      totalProcessingCurrencyChar: "",
      isValidConversion: true,
    };
  },
  methods: {
    loadAsyncData(params, sort) {
      sort = sort ? sort : "by_merchant";
      var paramRequest;
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token"),
        },
      };
      this.loading = true;

      paramRequest = Object.assign({}, params);

      if (this.isSidebarOpened) {
        setTimeout(() => {
          store.commit("hideSidebar");
        }, 500);
      }
      axios
        .post(apiUrl + "analytics/stats", paramRequest, config)
        .then(({ data }) => {
          this.isValidConversion = data.is_valid_conversion;
          if (sort == "by_merchant") this.tableData = data.data;
          if (sort == "by_processing") {
            this.tableProcessing = data.data;
            this.processingShow();
          }
          this.loading = false;
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.dataEmpty = true;
          this.loading = false;
          throw error;
        });
    },
    applyFilters(activeName) {
      if (!this.loading) {
        let req = {};
        for (const prop in this.request) {
          if (this.request.hasOwnProperty(prop)) {
            req[prop] = this.request[prop];
          }
        }
        if (activeName == "by_processing") req.expect[0] = "processing_verbose";
        if (activeName == "by_merchant") req.expect[0] = "merchant_verbose";
        req = _.pick(req, (val) => val.length > 0 || val == true);
        this.loadAsyncData(req, activeName);
      } else return false;
    },
    dateChange(value) {
      let start = moment(value.startDate).format("YYYY-MM-DDTHH:mm:ss.000000");
      let end = moment(value.endDate).format("YYYY-MM-DDTHH:mm:ss.999999");
      this.request.date_range = [start, end];
      //this.onValueChange([start, end]);
    },
    onValueChange(e) {
      //if (e.length == 0) this.request.terminals = [];
    },
    handleClickTab(tab, e) {
      if (tab.name === "by_processing") {
        this.request.expect[0] = "processing_verbose";
        this.temp_m.terminals = this.request.terminals;
        this.temp_m.merchants = this.request.merchants;
        this.request.terminals = this.temp_p.terminals;
        this.request.merchants = this.temp_p.merchants;
        if (this.tableProcessing == null || this.tableProcessing.length == 0)
          this.loadAsyncData(_.pick(this.request, (val) => val.length > 0 || val == true), tab.name);
      } else {
        this.temp_p.terminals = this.request.terminals;
        this.temp_p.merchants = this.request.merchants;
        this.request.terminals = this.temp_m.terminals;
        this.request.merchants = this.temp_m.merchants;
        this.request.expect[0] = "merchant_verbose";
      }
      this.tableHeight();
    },
    tableHeight() {
      let differ = this.activeName == "by_merchant" ? 375 : 408;
      let fHeight = document.querySelectorAll(".filters")[0].offsetHeight;
      fHeight = fHeight < 60 ? 0 : fHeight;
      differ = fHeight < 60 ? differ : 325;
      let dHeight = document.documentElement.clientHeight;
      this.tHeight = dHeight - (fHeight + differ);
    },
    rowClass(params) {
      const { row, index } = params;
      return row.merchant ? "is-merchant" : "is-terminal";
    },
    rowClick(row, column, event) {
      this.$refs.tfinance.toggleRowExpansion(row);
    },
    rowClickP(row, column, event) {
      this.$refs.tprocessing.toggleRowExpansion(row);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      let total = 0;
      let terminals = [];
      data.forEach((el) => {
        if (el.merchant == true) {
          total = total + el.amount;
          el.terminals.forEach((i) => terminals.push(i));
        }
      });
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "";
        }
        if (index === 1) {
          sums[index] = "Итого";
        }
        if (index === 2) {
          sums[index] =
            (total / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ") + " " + this.totalProcessingCurrencyChar;
        }
        if (!_.isUndefined(column.property) && column.property != "name" && column.property != "amount") {
          let key = JSON.parse(column.property);
          const reducer = (accumulator, currentValue) => {
            return accumulator + currentValue.amount;
          };
          let pSum = terminals.filter((el, i) => el.processing_id == key.proc).reduce(reducer, 0);
          if (!_.isUndefined(pSum) && pSum != 0)
            sums[index] =
              (pSum / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ") + " " + this.totalProcessingCurrencyChar;
          else sums[index] = "—";
        }
      });
      return sums;
    },
    cellFormatter(row, col) {
      let key = JSON.parse(col.property); // key - processing_id
      if (row.merchant) {
        let total = 0;
        row.terminals.forEach((el) => {
          if (el.processing_id === key.proc) total = total + parseFloat(el.amount);
        });
        console.log(row);
        if (total > 0)
          return (
            (total / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ") + " " + this.totalProcessingCurrencyChar
          );
        else return "—";
      } else {
        if (row.processing_id === key.proc) {
          return (
            parseFloat(row.amount / 100)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1 ") +
            " " +
            this.currencyCharacter(row.currency_code)
          );
        }
      }
      return "—";
    },
    totalFormatter(row, col) {
      let total = 0;
      if (!_.isUndefined(row.terminals)) {
        row.terminals.forEach((p) => {
          total = total + parseFloat(p.amount);
        });
      } else {
        total = parseFloat(row.amount);
      }
      return (
        (total / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ") + " " + this.currencyCharacter(row.currency_code)
      );
    },
    processingShow() {
      let processing = {};
      let procList = [];
      if (!_.isUndefined(this.tableProcessing) && !_.isNull(this.tableProcessing)) {
        this.tableProcessing.forEach((row) => {
          row.terminals.forEach((proc) => {
            let obj = { processing_id: proc.processing_id, show: true };
            procList.push(obj);
          });
        });
      }
      let uniq = _.uniq(procList, (item, key, a) => item.processing_id);
      this.processings = uniq;
    },
    defaultData() {
      var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth(),
        d = date.getUTCDate();
      let start = new Date(y, m, 1, 0, 0, 0, 0);
      let end = new Date(y, m, d, 23, 59, 59, 0);
      this.request.date_range = [
        moment(start).format("YYYY-MM-DDTHH:mm:ss.000000"),
        moment(end).format("YYYY-MM-DDTHH:mm:ss.999999"),
      ];
    },
    downloadReport(tab) {
      let paramRequest;
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token"),
        },
      };

      paramRequest = _.extend(_.pick(this.request, (val) => val.length > 0 || val == true), { download: true });

      this.loading = true;
      axios
        .post(apiUrl + "analytics/stats", paramRequest, config)
        .then(({ data }) => {
          this.url = data.download_url;
          let filename = data.filename;
          if (this.url && this.url != "") {
            fetch(this.url, {
              method: "GET",
              headers: { "Content-Type": "text/csv" },
            })
              .then(function(res) {
                return res.blob();
              })
              .then((myBlob) => {
                let url = window.URL.createObjectURL(myBlob);
                let link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
              })
              .catch((err) => {
                throw err;
              });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.$message.error("Не удалось обработать запрос");
          this.loading = false;
          throw error;
        });
    },
    merchantCurrencyCode(id) {
      if (this.tableData && this.tableData.length > 0) {
        const merchant = this.tableData.find((el) => el.id === id);
        if (merchant && merchant.terminals && merchant.terminals.length > 0) {
          const char = this.currencyCharacter(merchant.terminals[0].currency_code);
          this.totalCurrencyChar = char;
          return char;
        }
      }
      return id;
    },
    merchantProcessingCurrencyCode(id) {
      if (this.tableProcessing && this.tableProcessing.length > 0) {
        const merchant = this.tableProcessing.find((el) => el.id === id);
        if (merchant && merchant.terminals && merchant.terminals.length > 0) {
          const char = this.currencyCharacter(merchant.terminals[0].currency_code);
          this.totalProcessingCurrencyChar = char;
          return char;
        }
      }
      return id;
    },
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "merchantList",
      "merchantName",
      "terminalList",
      "terminalName",
      "processingList",
      "processingName",
      "processingIcon",
      "currencyCharacter",
      "isSidebarOpened",
    ]),
    terminalListSort() {
      let merchants = this.request.merchants;
      if (typeof merchants != "undefined" && this.activeName == "by_merchant") {
        if (merchants.length == 0) {
          this.request.terminals = [];
          return this.terminalList;
        } else {
          let terminals = [];
          merchants.forEach((el) => {
            if (typeof this.terminalList != "undefined") {
              let filtered = this.terminalList.filter((item) => item.merchant_id === el);
              terminals = terminals.concat(filtered);
            }
          });
          return terminals;
        }
      }
      return this.terminalList;
    },
    processingListSort() {
      if (this.request.terminals.length == 0) {
        return this.processingList;
      }
      let terminals = this.request.terminals.length > 0 ? this.request.terminals : this.terminalListSort;
      if (typeof terminals != "undefined") {
        if (terminals.length == 0) {
          this.request.processing = [];
        } else {
          let processing = [];
          terminals.forEach((el) => {
            let filtered = [];
            if (typeof this.processingList != "undefined") {
              if (_.isObject(el)) {
                filtered = this.processingList.filter((item) => item.id == el.processing_id);
              } else {
                filtered = this.processingList.filter(
                  (item) => item.id == _.findWhere(this.terminalList, { id: el }).processing_id
                );
              }
              processing = _.uniq(processing.concat(filtered));
            }
          });
          return processing;
        }
      }
      return this.processingList;
    },
    getSumm() {
      let totalAmount = 0;
      let totalCount = 0;
      if (!_.isUndefined(this.tableData) && !_.isNull(this.tableData)) {
        this.tableData.forEach((el) => {
          if (el.merchant) {
            totalAmount = totalAmount + el.amount;
            totalCount = totalCount + el.count;
          }
        });
      }
      return {
        totalAmount: totalAmount,
        totalCount: totalCount,
      };
    },
    pShow() {
      return this.processings.filter((e) => e.show);
    },
  },
  beforeMount() {
    this.defaultData();
    this.loadAsyncData(_.pick(this.request, (val) => val.length > 0 || val == true));
  },
  created() {
    this.$store.dispatch("getProcessing");
    this.$store.dispatch("getTerminal");
    this.$store.dispatch("getMerchant");
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.tableHeight);
      this.tableHeight();
    });
    if (this.isSidebarOpened) {
      setTimeout(() => {
        store.commit("hideSidebar");
      }, 500);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.tableHeight);
  },
  components: {
    Calendar,
  },
};
</script>

<style lang="sass">
@import '../assets/style/finance.sass'
</style>
